import * as React from 'react';
import { EmailField } from '@doordash/component-fields';
import { QuestionSectionContainer } from '../QuizV2Styles';
import { InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
export var EmailInputSection = function (_a) {
    var question = _a.question, emailLabel = _a.emailLabel, _b = _a.emailValue, emailValue = _b === void 0 ? '' : _b, _c = _a.emailError, emailError = _c === void 0 ? '' : _c, onEmailChange = _a.onEmailChange;
    return (React.createElement(QuestionSectionContainer, null,
        React.createElement(StackChildren, { size: Stack.Sizes.Small },
            React.createElement(InlineChildren, null,
                React.createElement(Text, { color: Text.Colors.TextSecondary, styles: Text.Styles.Title1 }, question)),
            React.createElement(EmailField, { label: emailLabel, value: emailValue, error: emailError, onChange: onEmailChange, isLabelHidden: true, autoFocus: true }))));
};
